module.exports = __webpack_public_path__ + "img/1迎賓車道圖.26af1330.jpg";